import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Utils, authJsonHeaders, handleSessionExpired } from '../../utils';
import { MdPeople, MdApps, MdNotifications, MdBusiness } from 'react-icons/md';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await fetch(Utils.baseurl + 'admin/dashboard/stats', {
                headers: authJsonHeaders(Utils.storageKeys.adminToken),
            });
            const result = await response.json();
            if (handleSessionExpired(response, result)) return;
            if (result.status) setStats(result.data);
        } catch (error) {
            console.error('Error fetching stats:', error);
        }
        setLoading(false);
    };

    const StatCard = ({ icon, label, value, color, subtext, onClick }) => (
        <div
            onClick={onClick}
            style={{
                background: 'white', borderRadius: '16px', padding: '24px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)', flex: '1', minWidth: '200px',
                cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                    width: '56px', height: '56px', borderRadius: '12px',
                    background: `${color}20`, display: 'flex', alignItems: 'center',
                    justifyContent: 'center', color: color
                }}>
                    {icon}
                </div>
                <div>
                    <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>
                        {loading ? '...' : (value || 0).toLocaleString()}
                    </div>
                    <div style={{ color: '#6b7280', fontSize: '14px' }}>{label}</div>
                    {subtext && <div style={{ color: '#10b981', fontSize: '12px', marginTop: '4px' }}>{subtext}</div>}
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <div style={{ marginBottom: '32px' }}>
                <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a', margin: 0 }}>Dashboard</h1>
                <p style={{ color: '#6b7280', marginTop: '8px' }}>Welcome to notifySphere Admin Panel</p>
            </div>

            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '32px' }}>
                <StatCard
                    icon={<MdPeople size={28} />}
                    label="Platform Users"
                    value={stats?.totalUsers}
                    color="#4f46e5"
                    subtext={stats?.recentUsers ? `+${stats.recentUsers} this week` : null}
                    onClick={() => navigate('/admin/users')}
                />
                <StatCard
                    icon={<MdApps size={28} />}
                    label="Applications"
                    value={stats?.totalApplications}
                    color="#10b981"
                    onClick={() => navigate('/admin/applications')}
                />
                {/* <StatCard
                    icon={<MdDevices size={28} />}
                    label="App Users"
                    value={stats?.totalAppUsers}
                    color="#f59e0b"
                    onClick={() => navigate('/admin/app-users')}
                /> */}
                <StatCard
                    icon={<MdNotifications size={28} />}
                    label="Subscriptions"
                    value={stats?.totalSubscriptions}
                    color="#ef4444"
                    onClick={() => navigate('/admin/plans')}
                />
                <StatCard
                    icon={<MdBusiness size={28} />}
                    label="Organizations"
                    value={stats?.totalOrganizations}
                    color="#8b5cf6"
                    onClick={() => navigate('/admin/users')}
                />
            </div>

            {stats?.usersByPlan && stats.usersByPlan.length > 0 && (
                <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                    <h3 style={{ margin: '0 0 20px 0', color: '#1a1a1a' }}>Users by Plan</h3>
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        {stats.usersByPlan.map((plan, idx) => (
                            <div
                                key={idx}
                                onClick={() => navigate('/admin/plans')}
                                style={{
                                    padding: '16px 24px', background: '#f3f4f6', borderRadius: '12px',
                                    textAlign: 'center', minWidth: '120px', cursor: 'pointer',
                                    transition: 'transform 0.2s, background 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.background = '#e5e7eb';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.background = '#f3f4f6';
                                }}
                            >
                                <div style={{ fontSize: '24px', fontWeight: '700', color: '#4f46e5' }}>{plan.count}</div>
                                <div style={{ color: '#6b7280', fontSize: '14px' }}>
                                    {plan.name || `Plan ${plan.plan_id}`}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
